const mutationTypes = {
  SET_USER_DATA: 'SET_USER_DATA',
}

const actionTypes = {
  FETCH_USER_DATA: 'FETCH_USER_DATA',
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/AccountSettingsTypes.js